import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";

interface CrossLink {
  label: string;
  to: string;
}

interface SolucoesCrossLinkProps {
  title: string;
  description: string;
  links: CrossLink[];
}

export default function SolucoesCrossLink({ title, description, links }: SolucoesCrossLinkProps) {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="grid grid-cols-1 gap-8 rounded-2xl border border-background-200 bg-background-100/60 p-8 md:p-12 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-primary-700">
                <i className="ri-sparkling-2-line" aria-hidden="true"></i>
                Soluções digitais
              </span>
              <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
                {title}
              </h2>
              <p className="mt-4 text-base leading-relaxed text-foreground-600">{description}</p>
              <Link
                to="/solucoes"
                className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                Conhecer as soluções digitais
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>

            <div>
              <p className="text-xs font-semibold uppercase tracking-wider text-foreground-400">
                Veja também
              </p>
              <ul className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="flex items-center justify-between gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
                    >
                      {link.label}
                      <i className="ri-arrow-right-up-line text-primary-500" aria-hidden="true"></i>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}